<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Relatório de Produtos Mais Vendidos</h3>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-menu
                  ref="menuCalendarDataInicio"
                  :close-on-content-click="false"
                  v-model="menuCalendarDataInicio"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :return-value.sync="modeloPesquisa.dataInicio"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dataInicioFormatada"
                    label="Data Inicio"
                    :rules="regras.data"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="modeloPesquisa.dataInicio"
                    locale="pt-br"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    required
                    @input="
                      $refs.menuCalendarDataInicio.save(
                        modeloPesquisa.dataInicio
                      )
                    "
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu
                  ref="menuCalendarDataFim"
                  :close-on-content-click="false"
                  v-model="menuCalendarDataFim"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :return-value.sync="modeloPesquisa.dataFim"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dataFimFormatada"
                    label="Data Fim"
                    :rules="regras.data"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="modeloPesquisa.dataFim"
                    locale="pt-br"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    required
                    @input="
                      $refs.menuCalendarDataFim.save(modeloPesquisa.dataFim)
                    "
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4>
                <v-btn
                  id="finalizar"
                  color="primary"
                  class="default-border"
                  depressed
                  :disabled="
                    modeloPesquisa.dataInicio == null &&
                    modeloPesquisa.dataFim == null
                  "
                  @click="buscarProdutos"
                  >Pesquisar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-data-table
            :headers="headers"
            :items="listaInfo"
            class="elevation-1"
            :search="filtro"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>
                {{ props.item.nome }}
              </td>
              <td>
                {{ props.item.quantidade }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";

export default {
  name: "ProdutosMaisVendidos",
  data: () => ({
    modeloPesquisa: {
      idConta: jwt.decryptToken().idconta,
      dataInicio: null,
      dataFim: null,
    },
    dataInicioFormatada: null,
    dataFimFormatada: null,
    menuCalendarDataInicio: false,
    menuCalendarDataFim: false,
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    filtro: "",
    pagination: { sortBy: "quantidade", descending: true, rowsPerPage: 20 },
    headers: [
      { text: "Nome Produto", value: "nome" },
      { text: "Quantidade", value: "quantidade" },
    ],
    listaInfo: [],
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
    },
  }),
  watch: {
    "modeloPesquisa.dataInicio": function (val) {
      this.dataInicioFormatada = val
        ? new Date(val).toLocaleDateString("pt-br", { timeZone: "UTC" })
        : "";

      var today = new Date(val);
      var tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 15);

      this.modeloPesquisa.dataFim = this.dataAtualFormatada(tomorrow);
    },
    "modeloPesquisa.dataFim": function (val) {
      this.dataFimFormatada = val
        ? new Date(val).toLocaleDateString("pt-br", { timeZone: "UTC" })
        : "";
    },
  },
  mounted: function () {
    this.externalSnackbarMessage();
  },
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
  },
  methods: {
    dataAtualFormatada(data) {
      var dia = data.getDate().toString().padStart(2, "0");
      var mes = (data.getMonth()).toString().padStart(2, "0"); //+1 pois no getMonth Janeiro começa com zero.
      var ano = data.getFullYear();
      return ano + "-" + mes + "-" + dia;
    },
    buscarProdutos: function () {
      const self = this;
      self.$http
        .post(
          `${process.env.URL_API}/produto/v1/busca/relatoriomaisvendido/`,
          self.modeloPesquisa,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          self.listaInfo = response.data;
        });
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/relatorio/ProdutosMaisVendidos.vue